export enum ImportSetSectionType {
  Details = 'details',
  Translations = 'translations'
}
